export const enum Colors {
  RED = 'red',
  BLUE = 'blue',
  GREEN = 'green',
  PINK = 'pink',
  PURPLE = 'purple',
  INDIGO = 'indigo',
  YELLOW = 'yellow'
}

export const enum Sides {
  LEFT = 'left',
  RIGHT = 'right'
}

export const enum GameStates {
  GAME_STARTED,
  GAME_OVER,
  PAUSED
}
